const assetURL = 'https://s3.amazonaws.com/uniteus-io-assets/app-client';

export const inNetworkMarker = `${assetURL}/location-markers/map-marker.svg`;
export const outOfNetworkMarker = `${assetURL}/location-markers/map-marker-oon.svg`;
export const inNetworkSelectedMarker = `${assetURL}/location-markers/map-marker-white.svg`;
export const outOfNetworkSelectedMarker = `${assetURL}/location-markers/map-marker-oon-white.svg`;
export const inNetworkMarkerOld = `${assetURL}/location-marker-icon.svg`;
export const outOfNetworkMarkerOld = `${assetURL}/location-outline-marker.svg`;
